import React, { useState } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { PublicKey, SystemProgram, Transaction } from '@solana/web3.js';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import './PurchaseComponent.css';

const PurchaseComponent = ({ guildId }) => {
  const { publicKey, sendTransaction } = useWallet();
  const [transactionSuccessful, setTransactionSuccessful] = useState(false);

  const handlePurchase = async () => {
    if (!publicKey) {
      alert('Please connect your wallet first!');
      return;
    }

    try {
      // Replace with the actual wallet address that will receive payments
      const paymentAddress = new PublicKey(process.env.REACT_APP_PAYMENT_WALLET_ADDRESS);

      // Create a transaction to send 1 SOL
      const transaction = new Transaction().add(
        SystemProgram.transfer({
          fromPubkey: publicKey,
          toPubkey: paymentAddress,
          lamports: 1000000000, // 1 SOL in lamports
        })
      );

      const response = await sendTransaction(transaction, { skipPreflight: false });

      // Assuming the transaction is successful after sending (you may want to verify further)
      console.log('Transaction Response:', response);
      setTransactionSuccessful(true);

      // Calculate subscription expiration date (1 year from now)
      const subscriptionExpiresAt = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);

      // Call API to update the subscription after success
      const res = await fetch('http://localhost:3002/api/update-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          walletAddress: publicKey.toString(),
          guildId: guildId, // Use the guildId provided as a prop
          subscriptionExpiresAt,
        }),
      });

      if (res.ok) {
        alert('Payment successful! Redirecting to setup page.');
        window.location.href = '/setup'; // Redirect user to setup page
      } else {
        alert('Failed to update subscription information.');
      }
    } catch (error) {
      console.error('Error during purchase:', error);
      alert('An error occurred during the transaction. Please try again.');
    }
  };

  return (
    <div className="purchase-container">
      <div className="purchase-card">
        <h1 className="purchase-header">Purchase Subscription</h1>
        <div className="wallet-button-wrapper">
          <WalletMultiButton />
        </div>
        {publicKey ? (
          <button className="purchase-button" onClick={handlePurchase}>
            Purchase for 1 SOL
          </button>
        ) : (
          <p>Please connect your wallet to proceed.</p>
        )}
        {transactionSuccessful && (
          <p className="success-message">Transaction successful! You now have access to the setup page.</p>
        )}
      </div>
    </div>
  );
};

export default PurchaseComponent;

